// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","778":"c7773329"}[chunkId] + "-" + {"218":"ec986b867ffa696e5228","532":"0ef39a7118272a882174","691":"6ad6ca1f5b407796a74a","778":"2170023770233b6737ef"}[chunkId] + ".js";
};